export const APP_STORE_URL = 'https://apps.apple.com/us/app/blindbook/id6751916153'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.blindbookai.app'
export const APP_STORE_BADGE_URL =
  'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83'
export const PLAY_STORE_BADGE_URL =
  'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
